/**
 * The German sentence an Alpha backend refusal carries: `CoreApiResponseDto.data` (the cp advice
 * answers 400/403/404/409 with it), `message` as second reader. A Blob body (file requests with
 * `responseType: 'blob'`) is read as text first. Returns null when there is no usable sentence
 * (empty, HTML, over-long technical text) so the caller falls back to its own wording.
 */
export async function cpServerMessage(error: any): Promise<string | null> {
    let body: any = error?.error;
    if (typeof Blob !== 'undefined' && body instanceof Blob) {
        const text = await body.text();
        try {
            body = JSON.parse(text);
        } catch {
            body = text;
        }
    } else if (typeof body === 'string') {
        try {
            body = JSON.parse(body);
        } catch {
            // plain text body
        }
    }
    const candidate = typeof body === 'string' ? body : (body?.data ?? body?.message);
    return typeof candidate === 'string' && candidate.trim().length && candidate.trim().length < 500
        && !candidate.trim().startsWith('<')
        ? candidate.trim()
        : null;
}
